import React, { FC, useContext } from "react"
import { useFormContext } from "react-hook-form"
import { UpdatePhoneNumberHeaderAndCopy } from "components/views/account/phoneNumberUpdate/UpdatePhoneNumberHeaderAndCopy"
import { HR, Spacer } from "components/views/atoms/Atoms"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Button } from "@carrotfertility/carotene"
import { CountryCodeAndPhoneNumberInputs } from "components/views/account/phoneNumberUpdate/CountryCodeAndPhoneNumberInputs"
import {
  PhoneNumberUpdateModalContext,
  ResendState
} from "components/views/account/phoneNumberUpdate/UpdatePhoneNumberModal"
import { MessageDescriptor, defineMessage, useIntl } from "react-intl"

const ResentButtonCopy: Record<ResendState, MessageDescriptor> = {
  READY: defineMessage({ defaultMessage: "Resend code" }),
  SENDING: defineMessage({ defaultMessage: "Sending" }),
  SENT: defineMessage({ defaultMessage: "Code resent" })
}

const UpdatePhoneNumberFormStep: FC = () => {
  const {
    register,
    formState,
    formState: { errors }
  } = useFormContext()
  const { onSubmit, onResend, resendState, onPhoneNumberChange, verificationCodeState } =
    useContext(PhoneNumberUpdateModalContext)
  const intl = useIntl()

  return (
    <>
      <UpdatePhoneNumberHeaderAndCopy />
      <CountryCodeAndPhoneNumberInputs onChange={onPhoneNumberChange} />
      <Spacer height={1.5} />
      {verificationCodeState === "AWAITING_VERIFICATION" && (
        <CompleteFormInput
          {...register("verificationCode", {
            required: intl.formatMessage({ defaultMessage: "Please enter the verification code" })
          })}
          errors={errors}
          label={intl.formatMessage({ defaultMessage: "Enter verification code" })}
        />
      )}
      <HR color="black-10" />
      <Spacer height={1.5} />
      {verificationCodeState === "AWAITING_VERIFICATION" ? (
        <div className="flex">
          <Button disabled={!(formState.isValid && formState.isDirty)} onClick={onSubmit}>
            {formState.isSubmitting
              ? intl.formatMessage({ defaultMessage: "Sending..." })
              : intl.formatMessage({ defaultMessage: "Confirm code" })}
          </Button>
          <Spacer width={0.5} />
          <Button variant="secondary" disabled={resendState === "SENDING"} onClick={onResend}>
            {intl.formatMessage(ResentButtonCopy[resendState])}
          </Button>
        </div>
      ) : (
        <Button
          onClick={onSubmit}
          disabled={
            !(formState.isValid && formState.isDirty && (!formState.isSubmitting || verificationCodeState === "SENT"))
          }
        >
          {formState.isSubmitting
            ? verificationCodeState === "SENT"
              ? intl.formatMessage({ defaultMessage: "Code sent!" })
              : intl.formatMessage({ defaultMessage: "Sending..." })
            : intl.formatMessage({ defaultMessage: "Send verification code" })}
        </Button>
      )}
      <Spacer height={1.5} />
    </>
  )
}

export { UpdatePhoneNumberFormStep }
